import { render, staticRenderFns } from "./download-file.vue?vue&type=template&id=5861e88e&scoped=true"
import script from "./download-file.vue?vue&type=script&lang=js"
export * from "./download-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861e88e",
  null
  
)

export default component.exports